import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { useAuthUserContext } from "../../context/AuthUser";
import { QuotationDetailSaveButtonName } from "../../model/form/QuotationDetailForm";
import { QuotationStatus } from "../../util/Constant";

type Props = {
  readOnly: boolean;
  statusClassValue: string;
  /** 保存系ボタン押下 */
  onClickAction: (name: QuotationDetailSaveButtonName) => void;
  /** 見積書PDF */
  onClickOutputPdf: () => void;
  onClose: () => void;
};

/**
 * 見積詳細モーダルのフッター
 * ステータス × ユーザ種別（顧客 / BEMAC）ごとに表示するボタンを切り替える。
 */
function QuotationDetailFooter(props: Props) {
  const { readOnly, statusClassValue, onClickAction, onClose } = props;
  const auth = useAuthUserContext();
  const { t: tc } = useTranslation("QuotationDetail");

  const pdfButton = (
    <Button
      className="b-btn-light"
      onClick={(e) => props.onClickOutputPdf()}
      data-cy="見積書PDFボタン"
    >
      {tc("見積書PDF")}
    </Button>
  );

  return (
    <>
      {
        // 下書き or 新規作成
        statusClassValue === QuotationStatus.DRAFT && (
          <>
            {auth.user().bemacFlg && (
              <>
                {!readOnly && (
                  <>
                    <Button
                      className="b-btn-light"
                      onClick={(e) => onClickAction("一時保存")}
                      data-cy="一時保存ボタン"
                    >
                      {tc("一時保存")}
                    </Button>
                    {!auth.isEngineer() && pdfButton}
                    <Button
                      className="b-btn-primary m-0"
                      onClick={(e) => onClickAction("見積回答")}
                      data-cy="見積回答ボタン"
                    >
                      {tc("見積回答")}
                    </Button>
                  </>
                )}
              </>
            )}
            {!auth.user().bemacFlg && (
              <>
                {!readOnly && (
                  <>
                    <Button
                      className="b-btn-light"
                      onClick={(e) => onClickAction("一時保存")}
                      data-cy="一時保存ボタン"
                    >
                      {tc("一時保存")}
                    </Button>
                    <Button
                      className="b-btn-primary m-0"
                      onClick={(e) => onClickAction("見積依頼")}
                      data-cy="見積依頼ボタン"
                    >
                      {tc("見積依頼")}
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )
      }
      {
        // 見積依頼中
        statusClassValue === QuotationStatus.REQUESTED && (
          <>
            {auth.user().bemacFlg && (
              <>
                {!readOnly && (
                  <Button
                    className="b-btn-light"
                    onClick={(e) => onClickAction("一時保存")}
                    data-cy="一時保存ボタン"
                  >
                    {tc("一時保存")}
                  </Button>
                )}
                {!auth.isEngineer() && pdfButton}
                {!readOnly && (
                  <Button
                    className="b-btn-primary m-0"
                    onClick={(e) => onClickAction("見積回答")}
                    data-cy="見積回答ボタン"
                  >
                    {tc("見積回答")}
                  </Button>
                )}
              </>
            )}
            {!auth.user().bemacFlg && (
              <>
                {!readOnly && (
                  <>
                    <Button
                      className="b-btn-light"
                      onClick={(e) => onClickAction("見積キャンセル")}
                      data-cy="見積キャンセルボタン"
                    >
                      {tc("見積キャンセル")}
                    </Button>
                    <Button
                      className="b-btn-primary m-0"
                      onClick={(e) => onClickAction("見積依頼変更")}
                      data-cy="見積依頼変更ボタン"
                    >
                      {tc("見積依頼変更")}
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )
      }
      {
        // 見積回答確認中
        statusClassValue === QuotationStatus.ANSWERED && (
          <>
            {auth.user().bemacFlg && <>{!auth.isEngineer() && pdfButton}</>}
            {!auth.user().bemacFlg && (
              <>
                {pdfButton}
                {!readOnly && (
                  <>
                    <Button
                      className="b-btn-light"
                      onClick={(e) => onClickAction("再見積依頼")}
                      data-cy="再見積依頼ボタン"
                    >
                      {tc("再見積依頼")}
                    </Button>
                    <Button
                      className="b-btn-light"
                      onClick={(e) => onClickAction("見積否認")}
                      data-cy="見積否認ボタン"
                    >
                      {tc("見積否認")}
                    </Button>
                    <Button
                      className="b-btn-primary m-0"
                      onClick={(e) => onClickAction("見積注文")}
                      data-cy="見積注文ボタン"
                    >
                      {tc("見積注文")}
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )
      }
      {
        // 見積承認後
        statusClassValue === QuotationStatus.ACCEPTED && (
          <>{!auth.isEngineer() && pdfButton}</>
        )
      }
      <Button className="b-btn-close" onClick={onClose} data-cy="Closeボタン">
        Close
      </Button>
    </>
  );
}

export default QuotationDetailFooter;
